// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.root[data-v-75161d08] .preview .centerer .w-card > .w-card-title{border-bottom: 0; border-radius: 0 0 0 0;}\n.root[data-v-75161d08] .preview .pdf-wrapper{padding: 0 0 0 0;}\n.root[data-v-75161d08] .preview iframe{border-radius: 0 0 0 0;}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
